module.exports = __webpack_public_path__ + "img/20200515_163915.f3481ebd.jpg";